import { Navigate, Outlet } from "react-router-dom";

import useAuth from "../hooks/useAuth";

const RequireGuest = ({ redirectUrl }) => {
  const { auth } = useAuth();

  if (auth?.accessToken) {
    return <Navigate replace to={redirectUrl} />;
  }

  return <Outlet />;
};

export default RequireGuest;
